import { LoginPage } from '@components/Login/LoginLanding';
    import { useTranslate } from '@i18n';
import { AuthLayout } from '@layouts';
import { type FC } from 'react';

const Login: FC = () => {
    const { t } = useTranslate();

    return (
        <AuthLayout title={t('common.login')}>
            <LoginPage />
        </AuthLayout>
    );
};

export default Login;
